<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings > Change Password</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- location -->
        <div class="loacatoin-box">
          <div class="row align-items-center">
            <div class="col-6">
              <h1>Change Password</h1>
            </div>
          </div>
          <div>
            <div class="row mb-10">
              <div class="col-6">
                <div class="row">
                  <div class="col-lg-12 pd-lr ">
                    <div class="form-group">
                      <label>
                        <span>Password *</span>
                      </label>
                      <div class="input-wrapper wrap1">
                        <input v-model="form.password"
                               v-validate="{ required:true, regex: /|^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*).{8,}$/ }"
                               name="password"
                               type="password" class="form-control form-control-lg" id="signin-password"
                               ref="password" @change="validateInput('password')">


                        <i class="ico-sec ico-eye_selected ico-pass"></i>
                      </div>
                      <p v-if="validity.password === 'invalid'"
                         :class="{textRed : validity.password === 'invalid'}">Enter password</p>
                    </div>

                  </div>
                  <div class="col-lg-12 pd-lr ">

                    <div class="form-group">
                      <label>Confirm Password</label>
                      <div class="input-wrapper wrap2">
                        <input v-model="form.confirmpassword" v-validate="'required|confirmed:password'"
                               id="conform-password" name="password_confirmation" type="password"
                               class="form-control form-control-lg" data-vv-as="password"
                               @change="validateInput('confirm_password')">
                        <i class="ico-sec ico-eye_selected con-pass"></i>
                      </div>
                      <p v-if="validity.confirm_password === 'invalid'"
                         :class="{textRed : validity.confirm_password === 'invalid'}">Enter confirm password</p>
                      <p v-if="validity.confirm_password === 'invalid-match'"
                         :class="{textRed : validity.confirm_password === 'invalid-match'}">Password not
                        matched</p>
                    </div>

                  </div>
                  <div class="col-lg-12">
                    <div class="">
                      <div class="required-meaages" v-show="pswdRequirements">
                        <h4>Password requirements:</h4>
                        <div class="txt-size"><span class="txt-color" v-show="eightChar">&#10004;</span> Must
                          contain 8 characters
                        </div>
                        <div class="txt-size"><span class="txt-color" v-show="oneSpecial">&#10004;</span> One
                          special character
                        </div>
                        <div class="txt-size"><span class="txt-color" v-show="oneCapital">&#10004;</span> One
                          capital letter
                        </div>
                        <div class="txt-size"><span class="txt-color" v-show="oneLower">&#10004;</span> One
                          small
                          letter
                        </div>
                        <div class="txt-size"><span class="txt-color" v-show="oneNum">&#10004;</span> One
                          number
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right mb-10">
                    <button @click="changePassword" class="btn btn-info" type="button">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import sidebar from "./sidebar";
import Swal from "sweetalert2";
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  components: {
    sidebar,
    Swal
  },
  props: [],
  data() {
    return {
      pswdRequirements: true,
      company_id: this.$store.getters.getSelectedCompany.id,
      form: {
        password: '',
        confirmpassword: '',
      },
      limit: 0,
      tenChar: false,
      eightChar: false,
      oneSpecial: false,
      oneCapital: false,
      oneLower: false,
      oneNum: false,
      validity: {
        password: '',
        confirm_password: '',
      },
    }
  },
  validations: {
    form: {
      password: {
        required,
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[#?!@$%^&*-]/.test(value);
          this.oneLower = containsLowercase;
          this.oneSpecial = containsSpecial;
          this.oneCapital = containsUppercase;
          this.oneNum = containsNumber;
          this.eightChar = value.length >= 8 ? true : false;
          return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial
          );
        },
        minLength: minLength(8),
      },
    }
  },
  watch: {
    form: {
      handler(val) {
//console.log(val,'val val ');
        if (val.password === '') {
          this.oneLower = false;
          this.oneSpecial = false;
          this.oneCapital = false;
          this.oneNum = false;
          this.eightChar = false;
        }
      },

    }
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
  },
  serverPrefetch() {
  },
  created() {
    return this.$v.$touch();
  },
  mounted() {
  },
  methods: {
    validateInput(fieldname = '') {
      if (fieldname === 'password' || fieldname === '') {
        if (this.form.password === '') {
          this.validity.password = 'invalid'
        } else {
          this.validity.password = ''
        }
      }
      if (fieldname === 'confirm_password' || fieldname === '') {
        if (this.form.confirmpassword === '') {
          this.validity.confirm_password = 'invalid'
        } else if (this.$validator.errors.has('password_confirmation') == true) {
          this.validity.confirm_password = 'invalid-match'
        } else {
          this.validity.confirm_password = '';
        }
      }
      if ( this.validity.password == '' && this.validity.confirm_password == '') {
        return true
      } else {
        return false
      }
    },
    changePassword() {
      this.submitted = true;
      if (this.validateInput()) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return false; // stop here if form is invalid
        } else {
          this.$axios({
            method: "post",
            data: {password:this.form.password,password_confirmation:this.form.confirmpassword},
            url: this.$ChangePassword,
            headers: this.getAuthHeader(),
          }).then((res) => {
            if (res.data.status == 200) {
              new Swal({
                title: "Password change successfully",
                icon: "success",
                text: "",
                type: "success",
                confirmButtonColor: "#3085d6",
              })
            }
            if (res.data.status == 402) {
              new Swal({
                title: res.data.message,
                icon: "warning",
                text: "",
                type: "warning",
                confirmButtonColor: "#3085d6",
              })
            }
          });
        }
      }
    }
  }
}
</script>
<style scoped>
.wrap1{
  position: relative;
}
.wrap2{
  position: relative;
}
.wrap2>i,.wrap1>i{
  position: absolute;
  right: 10px;
  top: 18px;
}


body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
</style>
